import React from "react";

import { Grid } from "@mui/material";

import CardBody from "../../../components/Card/CardBody";
import Card from "../../../components/Card/Card";

//Variabele importeren
import FormControlledInputTC from "../../../components/Forms/FormControlledInputTC";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import FormAsyncTC from "../../../components/Forms/FormAsyncTC";
import { useFormContext } from "react-hook-form";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";

function Allyoucaneat() {
  const { menukaartVestigingId } = useFormContext();

  return (
    <Card>
      <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
        <Grid container spacing={1} style={{ maxWidth: 600 }}>
          <Grid item xs={12}>
            <h3>
              <TranslationWrapper
                tDefault={"All you can eat settings"}
                tKey={"vestigingen.form.allyoucaneat.headers.allyoucaneatsettings"}
              />
            </h3>
          </Grid>
          <FormControlledInputTC
            decimals={0}
            name={"gerechten"}
            rules={{
              pattern: { value: /^[0-9]+$/, message: "Number must be positive!" },
            }}
            tDefault={"Items p.p. per order"}
            tKey={"vestigingen.form.allyoucaneat.label.gerechten"}
            type={"number"}
          />
          <FormControlledInputTC
            decimals={0}
            name={"pauze"}
            rules={{
              pattern: { value: /^[0-9]+$/, message: "Number must be positive!" },
            }}
            tDefault={"Wachtijd eten"}
            tKey={"vestigingen.form.allyoucaneat.label.pauze"}
            type={"number"}
          />
          <FormControlledInputTC
            decimals={0}
            name={"rondes"}
            rules={{
              pattern: { value: /^[0-9]+$/, message: "Number must be positive!" },
            }}
            tDefault={"Max rondes"}
            tKey={"vestigingen.form.allyoucaneat.label.rondes"}
            type={"number"}
          />
        </Grid>
        <Grid container spacing={1} style={{ maxWidth: 600 }}>
          <FormControlledInputTC
            decimals={0}
            name={"tijd"}
            rules={{
              pattern: { value: /^[0-9]+$/, message: "Number must be positive!" },
            }}
            tDefault={"Session lifetime"}
            tKey={"vestigingen.form.allyoucaneat.label.tijd"}
            type={"number"}
          />
          <FormControlledInputTC
            decimals={0}
            name={"pauzedrank"}
            rules={{
              pattern: { value: /^[0-9]+$/, message: "Number must be positive!" },
            }}
            tDefault={"Wachtijd drinken"}
            tKey={"vestigingen.form.allyoucaneat.label.pauzedrank"}
            type={"number"}
          />
          <FormSwitchTC
            name={"sessionHistory"}
            tDefault={"Session history"}
            tKey={"vestigingen.form.allyoucaneat.label.sessionHistory"}
          />
        </Grid>
        <Grid container spacing={1} style={{ maxWidth: 600 }}>
          <FormSwitchTC
            name={"addOrderRounds"}
            tDefault={"Round counter"}
            tKey={"vestigingen.form.allyoucaneat.label.addOrderRounds"}
          />
          <FormSwitchTC
            name={"showTimer"}
            tDefault={"Show time left"}
            tKey={"vestigingen.form.allyoucaneat.label.showTimer"}
          />
          <FormSwitchTC
            name={"extra_settings__forceAyce"}
            tDefault={"Force AYCE"}
            tKey={"vestigingen.form.allyoucaneat.label.extra_settings__forceAyce"}
          />
          <FormSwitchTC
            name={"extra_settings__requireTableActivation"}
            tDefault={"Require table activation"}
            tKey={"vestigingen.form.allyoucaneat.label.extra_settings__requireTableActivation"}
          />
          <FormSwitchTC
            name={"extra_settings__tableProductRequired"}
            tDefault={"Require table product"}
            tKey={"vestigingen.form.allyoucaneat.label.extra_settings__tableProductRequired"}
          />
          <FormSwitchTC
            name={"extra_settings__ayceMixMode"}
            tDefault={"Arrangement mix mode"}
            tKey={"vestigingen.form.allyoucaneat.label.extra_settings__ayceMixMode"}
          />
          <FormSwitchTC
            name={"extra_settings__syncTableState"}
            tDefault={"Sync table state"}
            tKey={"vestigingen.form.allyoucaneat.label.extra_settings__syncTableState"}
          />
          <FormControlledInputTC
            decimals={0}
            name={"extra_settings__syncTableTTL"}
            rules={{
              pattern: { value: /^[0-9]+$/, message: "Number must be positive!" },
            }}
            tDefault={"Sync table state"}
            tKey={"vestigingen.form.allyoucaneat.label.syncTableTTL"}
            type={"number"}
          />
          <FormSwitchTC
            name={"extra_settings__useTableSessions"}
            tDefault={"Use table sessions"}
            tKey={"vestigingen.form.allyoucaneat.label.extra_settings__useTableSessions"}
          />
          <FormSwitchTC
            name={"extra_settings__useArrangement"}
            tDefault={"Use arrangementen filter"}
            tKey={"vestigingen.form.allyoucaneat.label.extra_settings__useArrangement"}
          />
          <FormAsyncTC
            async={{
              url:
                "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                menukaartVestigingId,
              searchField: "naam",
            }}
            key={"orderRoundIds" + menukaartVestigingId}
            multiple={true}
            name={"orderRoundIds"}
            tDefault={"Producten"}
            tKey={"vestigingen.form.allyoucaneat.label.orderRoundIds"}
          />
          <FormAsyncTC
            async={{
              url:
                "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                menukaartVestigingId,
              searchField: "naam",
            }}
            key={"extra_settings__ayceSessionStartItems" + menukaartVestigingId}
            multiple={true}
            name={"extra_settings__ayceSessionStartItems"}
            tDefault={"Session activation products"}
            tKey={"vestigingen.form.allyoucaneat.label.extra_settings__ayceSessionStartItems"}
          />
          <FormAsyncTC
            async={{
              url:
                "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                menukaartVestigingId,
              searchField: "naam",
            }}
            key={"arrangementen" + menukaartVestigingId}
            multiple={true}
            name={"arrangementen"}
            tDefault={"Arrangementen"}
            tKey={"vestigingen.form.arrangementen.label.arrangementen"}
          />
        </Grid>
      </CardBody>
    </Card>
  );
}

export default Allyoucaneat;
